import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { postTerms, CMS_BASE_URL } from '../../redux/action';

import './home.css'; 
import '../common/common.css'; 

import accountBanner from '../../images/generalBanner.png';

class Contact extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	title: "Terms",
	    	terms: {}
	    };
    }

	componentWillMount() {
		

	}

	componentDidMount() {

		
		
		postTerms({}).then(res => {
				this.setState({ 
					terms: res.data.terms
				})
			}, this)
	}



	render() {

		return(
			<div className="geContainer">
				<Header urlKey={this.props.urlKey} />
				<div className="mainContainer">
					<img className="banner" src={accountBanner} />
					
						<div className="sectionContainer">
							<div class="headline containerMaxWidth">
								<h2>CONTACT US</h2>
							</div>
							<div className="bodyContent containerMaxWidth">
								<div>
									<h3>Daiichi Sankyo Hong Kong Limited</h3>
									<p>Address: Suites 3207-11, 32/F, Tower One, Times Square, 1 Matheson Street, Causeway Bay, Hong Kong</p>
									<p>Tel: <a href="tel:85228689072">(852) 2868 9072</a></p>
									<p>Fax: (852) 2801 4341</p>
									<p>Website: <a href="https://www.daiichisankyo.com.hk" target="_blank">https://www.daiichisankyo.com.hk</a></p>
								</div>
								<div>
									<br/>
									<h3>AstraZeneca Hong Kong Limited</h3>
									<p>Address: Unit 1-3, 11/F, China Taiping Finance Centre, 18 King Wah Road, North Point, Hong Kong</p>
									<p>Tel: <a href="tel:85224207388">(852) 2420 7388</a></p>
									<p>Fax: (852) 2422 6788</p>
									<p>Website: <a href="https://www.astrazeneca.com" target="_blank">https://www.astrazeneca.com</a></p>
								</div>
								<div>
								</div>
							</div>
						</div>
				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(Contact));